module.exports = "/_next/static/images/Functions@2x-22e075814cafea6d8f69854abc3e5484.png";